import Image from 'components/Image';
import AttributeRow from './AttributeRow';
import FollowersImage from 'images/icons/followers.png';
import styles from './styles/AttributeRowFollowers.module.scss';

export default function AttributeRowFollowers({ count, title = 'Followers' }: { count: number; title?: string }) {
  return (
    <AttributeRow title={title}>
      <div className={styles.Container}>
        <Image className={styles.Image} src={FollowersImage} alt="Followers" />
        {count}
      </div>
    </AttributeRow>
  );
}
